import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { changePage } from '../redux/app';

function withPageTitle(WrappedComponent) {
    const mapStateToProps = () => ({});

    const mapDispatchToProps = dispatch => ({
        changePage: title => dispatch(changePage(title)),
    });

    class WithPageTitle extends Component {
        static propTypes = {
            title: PropTypes.string,
            changePage: PropTypes.func.isRequired,
            t: PropTypes.func.isRequired,
        };

        static defaultProps = {
            title: 'menu',
        };

        componentDidMount() {
            this.props.changePage(this.props.t(this.props.title));
        }

        componentWillReceiveProps(nextProps) {
            // If the title has changed, it should be dispatched an update
            if (this.props.title !== nextProps.title) {
                this.props.changePage(this.props.t(nextProps.title));
            }
        }

        componentWillUnmount() {
            // Default back to a more usefull string in case
            // the next page loaded hasn't implemented the hoc
            this.props.changePage(this.props.t('menu'));
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    return connect(mapStateToProps, mapDispatchToProps)(translate('menu')(WithPageTitle));
}

export default withPageTitle;



/** WEBPACK FOOTER **
 ** /src/shared/hoc/withPageTitle.js
 **/